import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const SectionTitle = styled(Typography, {
  name: 'SectionTitle',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  fontFamily: 'Source Sans Pro Semibold',
  fontSize: '20px',
  lineHeight: '160%',
  marginTop: theme.spacing(2),
  color: theme.palette.text.primary,
}))
